const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)')

export default class Details {
    el: HTMLDetailsElement
    header: HTMLElement
    content: HTMLElement
    animation: null | Animation = null
    isClosing = false
    isExpanding = false
    scrollToOnOpen: boolean
    private onClickBound: (e: Event) => void

    constructor(el: HTMLDetailsElement, scrollToOnOpen = false) {
        this.el = el
        this.header = el.querySelector('summary') as HTMLElement
        this.content = el.querySelector('summary + *') as HTMLElement
        this.scrollToOnOpen = scrollToOnOpen
        this.onClickBound = (e: Event) => this.onClick(e)
        this.header.addEventListener('click', this.onClickBound)
    }

    destroy() {
        this.header.removeEventListener('click', this.onClickBound)
        if (this.animation) {
            this.animation.cancel()
        }
        this.el.style.height = this.el.style.overflow = ''
        this.el.classList.remove('closing')
        this.isClosing = this.isExpanding = false
    }

    private duration() {
        return prefersReducedMotion.matches ? 0 : 150
    }

    onClick(e: Event) {
        e.preventDefault()
        this.el.style.overflow = 'hidden'

        if (this.isClosing || !this.el.open) {
            this.open()
        } else if (this.isExpanding || this.el.open) {
            this.shrink()
        }
    }

    shrink() {
        this.isClosing = true

        const startHeight = `${this.el.offsetHeight}px`
        const endHeight = `${this.header.offsetHeight}px`

        if (this.animation) {
            this.animation.cancel()
        }

        this.el.classList.add('closing')

        this.animation = this.el.animate(
            {height: [startHeight, endHeight]},
            {duration: this.duration(), easing: 'ease-out'},
        )

        this.animation.onfinish = () => this.onAnimationFinish(false)
        this.animation.oncancel = () => (this.isClosing = false)
    }

    open() {
        this.el.style.height = `${this.el.offsetHeight}px`
        this.el.open = true
        window.requestAnimationFrame(() => this.expand())

        if (this.scrollToOnOpen) {
            const scrollToPosition = this.el.getBoundingClientRect().top + window.scrollY - window.innerHeight / 4
            window.scrollTo({top: scrollToPosition})
        }
    }

    expand() {
        this.isExpanding = true

        const startHeight = `${this.el.offsetHeight}px`
        const endHeight = `${this.header.offsetHeight + this.content.offsetHeight}px`

        if (this.animation) {
            this.animation.cancel()
        }

        this.animation = this.el.animate(
            {height: [startHeight, endHeight]},
            {duration: this.duration(), easing: 'ease-out'},
        )

        this.animation.onfinish = () => this.onAnimationFinish(true)
        this.animation.oncancel = () => (this.isExpanding = false)
    }

    onAnimationFinish(open: boolean) {
        this.el.open = open
        this.animation = null
        this.isClosing = false
        this.isExpanding = false
        this.el.style.height = this.el.style.overflow = ''
        this.el.classList.remove('closing')
    }
}
